import { ApiHandler } from '@eshop/api-client'
import type Eshop from '@eshop/type/eshop'

import { getPageType } from '#/local/service/dataLayer'

import { Config } from '#/global/helper/Config'

type ProductEshop = Eshop.Product<'detail' | 'price' | 'brand'>

// Create payload for dataLayer
const createPayload = (product: ProductEshop, quantitySales: number, breadcrumb?: string) => {
    return {
        event: 'add_to_cart',
        pageType: getPageType(),
        ecommerce: {
            currency: product.price.currencyCode,
            value: product.price.priceNoVatSales * quantitySales,
            items: [{
                item_id: product.code,
                item_name: product.detail.title,
                item_brand: product.brand?.title ?? '',
                item_category: breadcrumb ?? '',
                price: product.price.priceNoVatSales,
                quantity: quantitySales,
            }],
        },
        _clear: true,
    }
}

// Get breadcrumb from an API
// and add it with product to dataLayer
const pushEventAddToCartEshop = (product: ProductEshop, quantitySales: number) => {
    window.dataLayer ??= []

    const api = new ApiHandler({
        path: '/product/get-breadcrumb-eshop-by-id',
        parameters: {
            id: product.detail.categoryId,
        },
    })

    api.addResponseHandler('4xx', async () => {
        await api.handleError({
            hideMessage: !Config.isDevelopment(),
        })
    })

    api.send()
        .then(categories => categories?.map(category => category.title).join(' > '))
        .then((breadcrumb) => {
            const payload = createPayload(product, quantitySales, breadcrumb)
            window.dataLayer?.push(payload)
        })
        .catch((error) => {
            console.error('[GlobalListener-PushEventAddToCartEshop]:', error)
        })
}
export default pushEventAddToCartEshop
